import { createAction } from '@reduxjs/toolkit';

import type { IApiStore } from '../../../../../models/ecommerce/store/storeModel';
import type { StoreContextSettings } from './storeContextSettings';

export interface SelectPickupStorePayload {
    store: IApiStore;
    pickupPointId: string;
}

export const selectPickupStore = createAction<SelectPickupStorePayload>('store/selectPickupStore');

export interface SelectHomeDeliveryStorePayload {
    store: IApiStore;
}
export const selectHomeDeliveryStore = createAction<SelectHomeDeliveryStorePayload>(
    'store/selectHomeDeliveryStore',
);

export type SyncStorePayload = StoreContextSettings;

export const syncStore = createAction<SyncStorePayload>('store/syncStore');
